import React from 'react';
import ArrowRight from '@assets/images/arrow_right.svg';

import {ICustomerPotential} from "@services/customer/CustomerPotentials";
import { Country } from '@utils/constants/localisation';


interface CustomerPotentialProps {
    potential: ICustomerPotential;
    country?: Country;
};


const CustomerPotential: React.FC<CustomerPotentialProps> = ({potential, country}) => {
    return (
        <div style={{width: '100%'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                <div style={{flex: 1}}>
                    <p style={{color: '#C4C4C4'}}>
                        Created on: {potential.created_date}
                    </p>
                    <p>
                        {potential.vehicle}
                    </p>
                    <p>
                        {potential.id}
                    </p>
                </div>
                <div style={{flex: 1, textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                    <p style={{color: '#01E4D3', marginRight: '20px'}}>
                        {potential.stage}
                    </p>
                    <p style={{color: '#01E4D3', marginRight: '20px'}}>
                        Quote 2.1: {potential.quote_version == 2 ? "Found": "Not found"}
                    </p>
                    <p style={{color: '#01E4D3', marginRight: '20px'}}>
                        Quote Status: {potential.quote_version == 2 ? potential.quote_status : "N/A"}
                    </p>
                    <p style={{display: 'flex', alignItems: 'center'}}>
                        {potential.plan} <img src={ArrowRight} alt="Arrow Right" style={{marginLeft: '5px'}} />
                    </p>
                    <p style={{marginRight: '20px'}}>
                        Potential Owner: {potential.zoho_contact_name}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CustomerPotential;
